module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column start-centered item-detalhe-container"
  }, [_c('div', {
    staticClass: "row-flex centered-start item-detalhe-titulo"
  }, [_c('i', {
    staticClass: "item-detalhe-icone fa",
    class: _vm.icone
  }), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.titulo) + "\n      ")])]), _vm._v(" "), (!_vm.formatarValor) ? _c('div', {
    staticClass: "item-detalhe-valor"
  }, [_vm._v("\n      " + _vm._s(_vm.value) + " "), (_vm.link) ? _c('i', {
    staticClass: "fa fa-external-link"
  }) : _vm._e()]) : _c('div', {
    staticClass: "item-detalhe-valor"
  }, [_vm._v("\n      " + _vm._s(_vm._f("real")(_vm.value)) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a53d3f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/itemDetalheLicitacao.vue
// module id = 1842
// module chunks = 2